
import CustomerMenu from './CustomerMenu';

export default CustomerMenu;